import React from 'react';
import { useParams } from 'react-router-dom';
import { BLOG_COPY, blogPath, formatDate, getPost } from '@app/lib/blog';
import { COPY } from '@app/lib/content';
import { pagePath } from '@app/lib/site';
import { useLang } from '@app/lib/useLang';
import { NotFoundPage } from '../NotFoundPage';
import { PageHero } from '@widgets';
import pageStyles from '../pageStyles.module.css';
import BlogContent from './BlogContent';
import styles from './style.module.css';

const BlogPostPage: React.FC = () => {
  const lang = useLang();
  const { slug } = useParams();
  const post = getPost(slug, lang);
  if (!post) return <NotFoundPage />;
  const b = BLOG_COPY[lang];

  return (
    <main>
      <PageHero image={post.hero} title={post.h1} />
      <article className={`${pageStyles.wrapper} ${styles.article}`}>
        <nav className={pageStyles.breadcrumbs} aria-label="Breadcrumb">
          <a href={pagePath('home', lang)}>{COPY[lang].ui.home}</a> <span aria-hidden>›</span>{' '}
          <a href={blogPath(lang)}>{b.nav}</a>
        </nav>
        <p className={styles.date}>
          {b.published}: <time dateTime={post.date}>{formatDate(post.date, lang)}</time>
          {post.heroCredit && (
            <>
              {' · '}
              {b.coverPhoto}:{' '}
              {post.heroCreditUrl ? (
                <a href={post.heroCreditUrl} target="_blank" rel="noopener noreferrer">
                  {post.heroCredit}
                </a>
              ) : (
                post.heroCredit
              )}
            </>
          )}
        </p>
        <BlogContent blocks={post.blocks} />
      </article>
    </main>
  );
};

export default BlogPostPage;
